<template>
  <!--服务协议界面内容 -->
  <div style="width:100%;height:100%;background:#FAFAFA;overflow-y: auto">
    <!--<div class="titlebar">-->
    <!--<div class="back_div" @click="goback">-->
    <!--<img src="../assets/nav_ic_back_black.png" />-->
    <!--</div>-->
    <!--<div style="position:absolute;text-align: center;width:100%;height:50px;">服务政策</div>-->
    <!--</div>-->
    <!-- tabbar-->
    <div class="tab_container">
      <div :class="{ 'tab_item': true, changeborder: selected == 0 }" id="fridge"
        @click="tabClick('fridge_container', 0)">
        冰箱
      </div>
      <div :class="{ 'tab_item': true, changeborder: selected == 1 }" id="aircondition"
        @click="tabClick('air_container', 1)">
        空调
      </div><!-- 服务号:日电小家电-->
      <div :class="{ 'tab_item': true, changeborder: selected == 2 }" id="otherdevice"
        @click="tabClick('other_container', 2)">
        日电
      </div>
      <div :class="{ 'tab_item': true, changeborder: selected == 3 }" id="meilingdevice"
        @click="tabClick('meiling_container', 3)">
        美菱小家电
      </div>
    </div>
    <!--tab-container -->
    <div class="tabitem_container">
      <mt-tab-container v-model="active">
        <mt-tab-container-item id="fridge_container">
          <fridge-container :active="active"></fridge-container>
        </mt-tab-container-item>
        <mt-tab-container-item id="air_container">
          <aircondition-container :active="active"></aircondition-container>
        </mt-tab-container-item>
        <mt-tab-container-item id="other_container">
          <other-container :active="active"></other-container>
        </mt-tab-container-item>
        <mt-tab-container-item id="meiling_container">
          <meiling-container :active="active"></meiling-container>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>

<script>
import Aircondition from './Aircondition.vue'
import Fridge from './Fridge.vue'
import Other from './Other.vue'
import MeilingXD from './MeilingXiaoDian.vue'
export default {
  name: "Protocol",
  data() {
    return {
      active: 'fridge_container',
      selected: 0
    }
  },
  mounted() {

  },
  methods: {
    tabClick(indexid, index) {
      this.active = indexid;
      this.selected = index;
      console.log(this.active);
    },
    goback() {
      this.$router.go(-1);
    }
  },
  components: {
    'aircondition-container': Aircondition,
    'fridge-container': Fridge,
    'other-container': Other,
    'meiling-container': MeilingXD
  }
}
</script>

<style scoped>
.titlebar {
  width: 100%;
  height: 50px;
  text-align: center;
  display: inline-block;
  line-height: 50px;
  font-size: 16px;
  position: relative;
}

.back_div {
  width: 52px;
  height: 50px;
  float: left;
  /*position:absolute;*/
}

.back_div>img {
  width: 8px;
  height: 12px;
  margin-top: 25px;
  margin-left: 26px;
  transform: translate(-50%, -50%);
}

.tab_container {
  width: 100%;
  height: 42px;
  background: white;
  display: inline-block;
  line-height: 42px;
  border-bottom: 0.5px solid #EEEEEE;
  ;
  border-top: 0.5px solid #EEEEEE;
  ;
}

.tabitem_container {
  width: 100%;
  height: calc(100% - 100px);
}

.tab_item {
  /* width: 33%; */
  /*width:100%;  !*当前只支持冰箱*!*/
  width: 25%;
  height: 100%;
  font-size: 16px;
  text-decoration: none;
  float: left;
  white-space: nowrap;
}

.changeborder {
  border-bottom: 2px solid #28B9F5;
  color: #28B9F5;
}
</style>



// WEBPACK FOOTER //
// src/components/Protocol.vue